export default __webpack_public_path__ + "static/dog-with-leash-307e1ab5b7bb7f4ba7a0c3dec839c82d.png";